<template>
<span class="kt-portlet__head-icon">
    <slot></slot>
</span>
</template>

<script>
export default {

}
</script>